import React, {useEffect, useState} from 'react';
import {Card, Col, Flex, Row, Tag, Typography} from "antd";
const { Text } = Typography;
import { EnvironmentOutlined } from "@ant-design/icons";
import {StyledCard, StyledRentTypeTag, StyledTag} from "./ProductCard.styled";
import style from "./ProductCard.module.scss";
import {IoLocationSharp} from "react-icons/io5";
import {GoDotFill} from "react-icons/go";
import {useNavigate} from "react-router-dom";
import {ProductCardProps} from "../../models";
import {getProductThumbnail} from "../../actions";
import {connect} from "react-redux";
import {getProductList} from "../../../features/product/actions/Product.action";
import {withRouter} from "../../../utils/services/with-router";
import {ProductListFilterModel} from "../../../features/product/models";
const boxStyle: React.CSSProperties = {
    width: '100%',
    height: 100,
    borderRadius: 6,
    border: '1px solid #40a9ff',
};
const ProductCard = ({product,getProductThumbnail ,isOwner=false} :ProductCardProps) => {
    const BaseURL = process.env.REACT_APP_IMAGES_URL;
    const navigate = useNavigate();
    let status = product.productStatus.id;
    const [productThumbnail, setProductThumbnail] =
        useState<any>();

    return (
        <StyledCard    bordered={false} onClick={() => navigate( isOwner ? `/myProduct-detail/${product.id}`:`/product-detail/${product.id}`)}>
            <Flex align={"center"} justify={"space-between"} >
                <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                    {
                        product?.productImages?.length > 0 ?
                            <img className={style.customImg} alt={product?.name} loading={"lazy"} src={`${BaseURL}/${product?.productImages[0]?.url}`}
                                 width={100} height={100}/>
                            : <img className={style.customImg} src={require("assets/Logo/emptyImage.png")}/>
                    }

                </Col>
                <Col xs={15} sm={15} md={15} lg={15} xl={15}>
                    <Flex className={style.customTopAdDescription} vertical justify={"space-between"} >
                        <Text className={style.CardTitle}>{product?.name} </Text>
                        <Flex vertical gap={"small"}>
                                  <Flex >
                                      <StyledTag>{product?.category?.categoryTitle}</StyledTag>
                                      <StyledTag>{product?.category?.subCategoryTitle}</StyledTag>
                                  </Flex>
                                  <Flex justify={"space-between"}>
                                      <Flex align={"center"} gap={"small"}>
                                          <span className={style.cardFooterSpan}>  <IoLocationSharp /> {product?.city?.provinceName} </span>
                                          <span className={status === 1 ? style.available: status === 5?  style.unavailable: style.inProgress}><GoDotFill /> {product?.productStatus?.description} </span>
                                      </Flex>
                                      <Flex     align={"center"} gap={"small"}>
                                          <Flex>
                                              <span className={style.price}>{product?.firstPricing?.price}</span>
                                              <span className={style.price}>ت</span>
                                          </Flex>
                                          <StyledRentTypeTag>{product?.firstPricing?.title}</StyledRentTypeTag>
                                      </Flex>
                                  </Flex>
                        </Flex>
                    </Flex>
                </Col>
            </Flex>
        </StyledCard>
    );
};

export default connect(null, {getProductThumbnail})(withRouter(ProductCard));
